import React, { useState } from 'react'
import { createPortal } from 'react-dom'

import { ModalWrapper, BodyWrapper } from './wrapper.css'
import Layout from '../Layout/Layout'
import CurrencyList from './CurrencyList/currencyList'
import store from '../../../../../../../redux'
import { strings } from '../../../../../../../i18n'

import { hideScreenModal } from '../../../../../../../redux/stores/ScreenModalStore/action'
import hideAnimation from '../../../../../../../services/hideAnimation'
import Selector from '../../../../../../elements/Selector/Selector'
import { paywayChangeHandled } from '../../Payways'
import Icon from '../../../../../../elements/Icon/Icon'

const selectCurrencyCode = (event, side, currencySelectHandler, hideAnimation) => {
    currencySelectHandler(event, side)
    hideAnimation(`selectModal-${side.toLowerCase()}`, hideScreenModal)
}


const currencyModal = (side, array, currencySelectHandler, searchValue, setSearch) => {

    const mainCoin = ['UAH', 'RUB', 'BTC', 'ETH', 'ETH_USDT', 'TRX_USDT', 'LTC', 'XRP', 'USDC', 'ETH_DAIM', 'ETH_SHIB', 'XLM', 'ETC', 'TRX', 'DOGE', 'BNB', 'BNB_SMART', 'BNB_SMART_ADA', 'ETH_LINK', 'ETH_UNI', 'BCH', 'XMR', 'TON']

    const android = window.navigator.userAgent.indexOf('Chrome')

    return (
        <BodyWrapper
            id={'list'}
        >
            <div className='search-wrap'>
                <div className='back-btn' onClick={() => {
                    hideAnimation(`selectModal-${side.toLowerCase()}`, hideScreenModal)
                }}>
                    <Icon icon='ARROW_BACK' color='#F7F7F7' size={24} />
                </div>
                <div className='search__wrapper' style={{ marginTop: 10 }}>
                    <input
                        type={'text'}
                        placeholder={strings('mobileExchanger.modal.search')}
                        onChange={event => {
                            setSearch(event.target.value.toString().trim().toUpperCase())
                        }}
                        style={{ paddingLeft: 16, height: android !== -1 ? 50 : 40, paddingTop: android === -1 ? 10 : 0 }}
                    />
                    <Icon icon='SEARCH' size={26} style={{ marginTop: android === -1 ? 15 : 13, marginRight: 16 }} />
                </div>
            </div>
            {searchValue ?
                <div style={{ marginLeft: '16px', marginRight: '16px', width: 'calc(100% - 32px)', marginTop: 16 }}>
                    {array.filter(way => mainCoin.includes(way)).filter(item => item.includes(searchValue)).map((item, index) => {
                        return (
                            <>
                                <CurrencyList
                                    key={item}
                                    item={item}
                                    index={index}
                                    handler={selectCurrencyCode}
                                    side={side}
                                    hideAnimation={hideAnimation}
                                    currencySelectHandler={currencySelectHandler}
                                />
                            </>
                        )
                    })}
                </div>
                :
                <>
                    <div style={{ paddingBottom: 150, WebkitOverflowScrolling: 'touch', marginLeft: 16, marginRight: 16 }}>
                        {array && array.length ? array.filter(way => mainCoin.includes(way)).map((item, index) => {
                            return (
                                <>
                                    <CurrencyList
                                        key={item}
                                        item={item}
                                        index={index}
                                        handler={selectCurrencyCode}
                                        side={side}
                                        hideAnimation={hideAnimation}
                                        currencySelectHandler={currencySelectHandler}
                                    />
                                </>
                            )
                        }) : null}
                    </div>
                </>
            }
        </BodyWrapper>
    )
}

const paywayModal = (arrayPayways, searchValue, setSearch) => {
    const state = store.getState().firstScreen

    const android = window.navigator.userAgent.indexOf('Chrome')

    const mainPayway = ['VISA_MC_P2P', 'VISA_MC', 'QIWI', 'MOBILE_PHONE']

    console.log(arrayPayways.filter(way => mainPayway.includes(way)))

    return (
        <BodyWrapper>
            <div className='search-wrap'>
                <div className='back-btn' onClick={() => {
                    hideAnimation('selectModal-payway', hideScreenModal)
                }}>
                    <Icon icon='ARROW_BACK' color='#F7F7F7' size={24} />
                </div>
                <div className='search__wrapper' style={{ marginTop: 10 }}>
                    <input
                        type={'text'}
                        placeholder={strings('mobileExchanger.modal.search')}
                        onChange={event => {
                            setSearch(event.target.value.toString().trim().toUpperCase())
                        }}
                        style={{ paddingLeft: 16, height: android !== -1 ? 50 : 40, paddingTop: android === -1 ? 10 : 0 }}
                    />
                    <Icon icon='SEARCH' size={26} style={{ marginTop: android === -1 ? 15 : 13, marginRight: 16 }} />
                </div>
            </div>
            {searchValue ?
                arrayPayways.filter(way => mainPayway.includes(way)).filter(item => item.includes(searchValue)).map((item, index) => {
                    return (
                        <>
                            <Selector
                                item={item}
                                index={index}
                                handler={paywayChangeHandled}
                                checked={state.payway === item}
                                active={true}
                            />
                            {(arrayPayways.filter(item => item.includes(searchValue)).length !== index) && <div className='line' style={{ paddingTop: '0px' }} ></div>}
                        </>
                    )
                })
                :
                <>
                    {arrayPayways.filter(way => mainPayway.includes(way)).map((item, index) => {
                        return (
                            <>
                                <Selector
                                    item={item}
                                    index={index}
                                    handler={paywayChangeHandled}
                                    checked={state.payway === item}
                                    active={true}
                                />
                                {(arrayPayways.length !== index) && <div className='line' style={{ paddingTop: '0px' }} ></div>}
                            </>
                        )
                    })}
                </>
            }
        </BodyWrapper>
    )
}

const SelectModal = (props) => {

    const { show, data, callback } = props

    const { side, array, currencySelectHandler } = data.data


    const [searchValue, setSearch] = useState(null)

    return (
        <>
            {show &&
                createPortal(
                    <Layout
                        id={`selectModal-${side.toString().toLowerCase()}`}
                        close={data.close}
                        show={show}
                        side={side}
                    >
                        <ModalWrapper>
                            {side === 'IN' && currencyModal('IN', array, currencySelectHandler, searchValue, setSearch)}
                            {side === 'OUT' && currencyModal('OUT', array, currencySelectHandler, searchValue, setSearch)}
                            {side === 'PAYWAY' && paywayModal(array, searchValue, setSearch)}
                            <div className={'modal__shadow'} />
                        </ModalWrapper>
                    </Layout>,
                    document.body)}
        </>
    )
}

export default SelectModal